import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-modal-motivos',
  templateUrl: 'modal-motivos.html',
})
export class ModalMotivosPage {

  // #region Propidades
  public motivos: string[] = [];
  // #endregion

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController) {
  }

  ionViewDidLoad() {
    this.motivos = <string[]>this.navParams.get("motivos");

    console.log("Lista de motivos: ");
    console.log(this.motivos);
  }

  public SeleccionarMotivo(motivo:string):void{
    this.viewCtrl.dismiss(motivo);
  }
}



// WEBPACK FOOTER //
// ./src/pages/modal-motivos/modal-motivos.ts